/* FDP discount-link dropdown
   Shows a slide-down notice when a shopper lands on a URL carrying a discount code
   (e.g. /?discount=WELCOME) and submits that code to Shopify's cart.
   Only the entry URL triggers it - a leftover discount_code cookie from an earlier
   visit doesn't. We save the current cart codes before requesting /discount/CODE,
   then clear previous submitted codes and apply only the URL code through
   cart/update.js. If replacement fails, we attempt to restore the saved codes.
   Cookie presence alone is not proof of an applied discount.
   Automatic discounts and eligibility remain controlled by Shopify.
   (Plain /discount/CODE links still apply the code but redirect to a clean URL,
   so they won't show the notice.) Shown once per code per browser session.
   Markup: snippets/fdp-discount-dropdown.liquid (rendered from layout/theme.liquid)
   Styles: compiled into sg-custom.css from 2_0-0-1custom-less/fdp-discount-dropdown.less
   Production diagnostics are commented out. For development debugging, uncomment
   the console calls (including the multiline cart-details block) and logCookie calls. */
(function(){
  try{
    var param=new URLSearchParams(location.search).get('discount');
    if(!param) return;
    var code=param.replace(/\+/g,' ').trim();
    if(!code) return;
    var routeRoot=window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if(!routeRoot) routeRoot=(window.routes && window.routes.root) || '/';
    routeRoot=routeRoot.replace(/\/$/,'')+'/';
    var discountUrl=routeRoot+'discount/'+encodeURIComponent(code);
    var cartUrl=routeRoot+'cart.js';
    var cartUpdateUrl=routeRoot+'cart/update.js';
    // console.info('[FDP discount] Discount URL from query:',discountUrl);
    var key='fdp_dd_shown_'+code.toLowerCase();
    var popupAlreadyShown=false;
    try{
      popupAlreadyShown=!!sessionStorage.getItem(key);
      if(popupAlreadyShown){
        // console.info('[FDP discount] Popup was already shown for this code in this session; will still apply/check the discount:',code);
      }
    }catch(e){}

    var root=document.getElementById('fdp-dd');
    if(!root){
      // console.warn('[FDP discount] Popup markup #fdp-dd was not found; will still apply/check the discount without showing the notice.');
    }else{
      var codeNode=root.querySelector('[data-fdp-dd-code]');
      if(codeNode) codeNode.textContent=code;
    }
    var timer, paused=false, remaining=12000, started;

    function close(){
      clearTimeout(timer);
      root.classList.remove('is-open');
      setTimeout(function(){ root.hidden=true; },450);
      document.removeEventListener('keydown',onKey);
      document.removeEventListener('pointerdown',onOutside,true);
    }
    function onKey(e){ if(e.key==='Escape') close(); }
    // Click/tap anywhere outside the card closes it
    // The first tap outside only dismisses the card; it doesn't also open whatever link was under it
    function swallowClick(e){ e.preventDefault(); e.stopPropagation(); document.removeEventListener('click',swallowClick,true); }
    function onOutside(e){
      var card=root.querySelector('.fdp-dd__card');
      if(card && !card.contains(e.target)){
        document.addEventListener('click',swallowClick,true);
        setTimeout(function(){ document.removeEventListener('click',swallowClick,true); },700);
        close();
      }
    }
    function arm(ms){ started=Date.now(); timer=setTimeout(close,ms); }

    if(root){
      var closeButton=root.querySelector('.fdp-dd__x');
      if(closeButton) closeButton.addEventListener('click',close);
      // Pause auto-close while the shopper is reading it
      root.addEventListener('mouseenter',function(){ if(!paused){ paused=true; clearTimeout(timer); remaining=Math.max(3000,remaining-(Date.now()-started)); } });
      root.addEventListener('mouseleave',function(){ if(paused){ paused=false; remaining=12000; arm(remaining); } });
    }

    function open(){
      // mark as seen only once it actually shows (survives redirect/reload chains)
      try{ if(sessionStorage.getItem(key)) return; sessionStorage.setItem(key,'1'); }catch(e){}
      root.hidden=false;
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ root.classList.add('is-open'); arm(remaining); document.addEventListener('keydown',onKey); document.addEventListener('pointerdown',onOutside,true); }); });
    }
    function getDiscountCookie(){
      var m=document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
      if(!m) return '';
      try{ return decodeURIComponent(m[1]).replace(/\+/g,' ').trim(); }
      catch(e){
        // console.warn('[FDP discount] Could not decode the visible discount cookie; cart data will still be checked.');
        return '';
      }
    }
    function responseDetails(response){
      return {
        url:response.url,
        status:response.status,
        statusText:response.statusText,
        ok:response.ok,
        redirected:response.redirected,
        type:response.type
      };
    }
    function logCookie(stage){
      // console.info('[FDP discount] Current discount_code cookie '+stage+':',getDiscountCookie() || '(not visible to JavaScript or not set)');
    }
    function readCartResponse(response){
      // console.info('[FDP discount] Cart response:',responseDetails(response));
      return response.json().then(function(cart){
        if(!response.ok || !cart || cart.errors || cart.status>=400){
          // console.error('[FDP discount] Shopify rejected the cart request:',cart);
          throw new Error('Cart request failed (HTTP '+response.status+').');
        }
        if(!Array.isArray(cart.items) || typeof cart.item_count!=='number'){
          throw new Error('Cart request returned an unexpected response.');
        }
        return cart;
      });
    }
    function getCart(){
      // console.info('[FDP discount] Reading Shopify cart before changing discounts:',cartUrl);
      return fetch(cartUrl,{
        credentials:'same-origin',
        cache:'no-store',
        headers:{'Accept':'application/json'}
      }).then(readCartResponse);
    }
    function updateCartDiscount(discount){
      // console.info('[FDP discount] Updating Shopify cart discount codes:',cartUpdateUrl,{discount:discount});
      return fetch(cartUpdateUrl,{
        method:'POST',
        credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({discount:discount})
      }).then(readCartResponse);
    }
    function getApplications(cart){
      var applications=(cart.cart_level_discount_applications || []).slice();
      cart.items.forEach(function(item){
        (item.line_level_discount_allocations || []).forEach(function(allocation){
          if(allocation.discount_application) applications.push(allocation.discount_application);
        });
      });
      return applications;
    }
    function getCartCodes(cart,workingOnly){
      var codes=[];
      function addCode(value){
        if(typeof value!=='string' || !value.trim()) return;
        var candidate=value.trim();
        if(!codes.some(function(saved){ return saved.toLowerCase()===candidate.toLowerCase(); })) codes.push(candidate);
      }
      getApplications(cart).forEach(function(application){
        if(application.type==='discount_code') addCode(application.title);
      });
      if(Array.isArray(cart.discount_codes)){
        cart.discount_codes.forEach(function(discount){
          if(!workingOnly || discount.applicable!==false || cart.item_count===0) addCode(discount.code);
        });
      }
      return codes;
    }
    function verifyCartCodes(cart,expectedCodes){
      var applications=getApplications(cart);
      var actualCodes=getCartCodes(cart,false);
      var otherCodes=actualCodes.some(function(actual){
        return !expectedCodes.some(function(expected){ return actual.toLowerCase()===expected.toLowerCase(); });
      });
      if(otherCodes) throw new Error('Shopify still reports a different submitted discount code.');
      var confirmed=expectedCodes.every(function(expected){
        var expectedLower=expected.toLowerCase();
        var applied=applications.some(function(application){
          return application.type==='discount_code' && String(application.title).toLowerCase()===expectedLower;
        });
        var applicable=Array.isArray(cart.discount_codes) && cart.discount_codes.some(function(discount){
          return String(discount.code).toLowerCase()===expectedLower && discount.applicable===true;
        });
        return applied || applicable;
      });
      if(cart.item_count>0 && !confirmed){
        throw new Error('Shopify did not confirm the requested discount codes for the current cart.');
      }
      return confirmed;
    }
    function syncCouponInputs(discount){
      try{
        if(discount) localStorage.setItem('storedDiscount',discount);
        else localStorage.removeItem('storedDiscount');
      }catch(e){}
      document.querySelectorAll('input[name="discount"]').forEach(function(input){ input.value=discount; });
    }
    function requestDiscountLink(url){
      // console.info('[FDP discount] Requesting discount URL:',url);
      return fetch(url,{credentials:'same-origin',redirect:'manual'}).then(function(response){
        // console.info('[FDP discount] Discount-link response (manual redirects may be opaque):',responseDetails(response));
        // logCookie('after discount-link request');
      }).catch(function(error){
        // console.warn('[FDP discount] Discount-link request failed; will still update the cart directly:',url,error);
      });
    }

    var previousCodes=[];
    var snapshotTaken=false;
    var discountMutationStarted=false;
    var replacementCommitted=false;
    // Snapshot Shopify's cart before either the native link or cart API changes it.
    // Cookie/localStorage values alone can be stale and are not rollback sources.
    // logCookie('before request');
    getCart().then(function(cart){
      previousCodes=getCartCodes(cart,true);
      snapshotTaken=true;
      // console.info('[FDP discount] Saved previous Shopify cart discount codes for rollback:',previousCodes);
      discountMutationStarted=true;
      return requestDiscountLink(discountUrl);
    }).then(function(){
      // Explicitly remove previous submitted codes; automatic discounts are not removed.
      return updateCartDiscount('');
    }).then(function(){
      syncCouponInputs('');
      return updateCartDiscount(code);
    }).then(function(cart){
      // logCookie('after cart update');
      var applications=getApplications(cart);
      // console.info('[FDP discount] Shopify cart discounts after replacement:',{
      //   requestedCode:code,
      //   discountCodes:cart.discount_codes,
      //   applications:applications,
      //   itemCount:cart.item_count,
      //   totalDiscount:cart.total_discount
      // });
      // Throw on unconfirmed/nonmatching codes so the failure path restores the snapshot.
      var confirmed=verifyCartCodes(cart,[code]);
      replacementCommitted=true;
      // Keep existing coupon inputs in sync so checkout cannot resubmit an old code.
      syncCouponInputs(code);
      if(confirmed){
        // console.info('[FDP discount] SUCCESS: Shopify cart confirms the URL discount code:',code);
      }else{
        // console.info('[FDP discount] Code submitted to an empty cart; savings cannot be verified until eligible items are added:',code);
        if(root){
          var title=root.querySelector('.fdp-dd__title');
          var text=root.querySelector('.fdp-dd__text');
          if(title) title.textContent='Your discount code is ready';
          if(text){
            text.textContent='Code '+code+' has been submitted. Eligibility and savings will be checked when you add items and proceed to checkout.';
          }
        }
      }

      if(!root || popupAlreadyShown){ return; }
      if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setTimeout(open,800); });
      else setTimeout(open,800);
    }).catch(function(error){
      if(replacementCommitted){
        // console.error('[FDP discount] Cart replacement succeeded, but updating the notice failed:',error);
        return;
      }
      // console.error('[FDP discount] FAILED: could not replace the cart discount:',code,error);
      if(!snapshotTaken || !discountMutationStarted){
        // console.warn('[FDP discount] Could not save the previous cart state; no discount changes were attempted.');
        return;
      }
      var previousDiscount=previousCodes.join(',');
      // console.warn('[FDP discount] Restoring previous Shopify cart discount codes:',previousCodes);
      // Restore the native-link cookie too when there was a previous submitted code.
      var restoreLink=previousDiscount ? requestDiscountLink(routeRoot+'discount/'+encodeURIComponent(previousDiscount)) : Promise.resolve();
      return restoreLink.then(function(){
        return updateCartDiscount('');
      }).then(function(cart){
        if(!previousDiscount) return cart;
        return updateCartDiscount(previousDiscount);
      }).then(function(cart){
        var restored=verifyCartCodes(cart,previousCodes);
        syncCouponInputs(previousDiscount);
        // logCookie('after rollback');
        if(restored){
          // console.info('[FDP discount] ROLLBACK SUCCESS: previous cart discount codes restored:',previousCodes);
        }else{
          // console.info('[FDP discount] Previous codes resubmitted to an empty cart; eligibility cannot yet be verified:',previousCodes);
        }
      }).catch(function(rollbackError){
        // console.error('[FDP discount] ROLLBACK FAILED: previous cart discounts could not be confirmed. Check cart/checkout before continuing:',previousCodes,rollbackError);
      });
    });
  }catch(e){
    // console.error('[FDP discount] Initialization failed:',e);
  }
})();
